// extracted by mini-css-extract-plugin
export default {"incut":"LwMcRvjZ","mobile":"mobile","icon":"N8AW38eT"};